import React from 'react'
import { matchPath } from 'react-router-dom'

import { PREFERENCE_MAP } from '@acre/utils'
import { MortgageReason, useGetCaseQuery } from '@acre/graphql'
import { Icon, IconTypes } from '@acre/design-system'

import { NavContent } from './Nav.helpers'
import { GreyLink } from './Nav.styles'

type Props = {
  pathname: string
}

const CasePropertyNav = ({ pathname }: Props) => {
  const match = matchPath(
    {
      path: '/properties/:propertyId/case/:caseId/:propertyType',
    },
    pathname,
  )
  const caseId = match!.params.caseId!

  const { data, loading, error } = useGetCaseQuery({
    variables: { id: caseId },
  })

  const reason = data?.case.details.preference_mortgage_reason || MortgageReason.InvalidMortgageReason

  if (loading || error) {
    return <NavContent iconName={IconTypes.Home} copyId="clients.properties.properties" />
  }

  return (
    <>
      <GreyLink to={`/cases/${caseId}/overview`}>
        <NavContent iconName={IconTypes.Cases} copyId={PREFERENCE_MAP[reason]} />
      </GreyLink>
      <Icon name={IconTypes.ArrowRight} />
      <NavContent iconName={IconTypes.Home} copyId="clients.properties.properties" />
    </>
  )
}

export default CasePropertyNav
